export const REQUEST_AI_TOOL_PUBLISH = 'aiLab/REQUEST_AI_TOOL_PUBLISH';
export const REQUEST_AI_TOOL_PUBLISH_SUCCESS = 'aiLab/REQUEST_AI_TOOL_PUBLISH_SUCCESS';
export const REQUEST_AI_TOOL_PUBLISH_FAILURE = 'aiLab/REQUEST_AI_TOOL_PUBLISH_FAILURE';

export const REQUEST_CLAIM_LEVEL_AI_TOOLS = 'aiLab/REQUEST_CLAIM_LEVEL_AI_TOOLS';
export const RECEIVE_CLAIM_LEVEL_AI_TOOLS = 'aiLab/RECEIVE_CLAIM_LEVEL_AI_TOOLS';

export const REQUEST_EXECUTE_AI_TOOL = 'aiLab/REQUEST_EXECUTE_AI_TOOL';
export const REQUEST_EXECUTE_AI_TOOL_SUCCESS = 'aiLab/REQUEST_EXECUTE_AI_TOOL_SUCCESS';
export const REQUEST_EXECUTE_AI_TOOL_FAILURE = 'aiLab/REQUEST_EXECUTE_AI_TOOL_FAILURE';

export const SUBMIT_AI_TOOL_INPUT = 'aiLab/SUBMIT_AI_TOOL_INPUT';
export const SUBMIT_AI_TOOL_INPUT_SUCCESS = 'aiLab/SUBMIT_AI_TOOL_INPUT_SUCCESS';
export const SUBMIT_AI_TOOL_INPUT_FAILURE = 'aiLab/SUBMIT_AI_TOOL_INPUT_FAILURE';
export const RESET_AI_TOOL_EXECUTION = 'aiLab/RESET_AI_TOOL_EXECUTION';

export const REQUEST_MATCH_RUNTIME_BUNDLE = 'aiLab/REQUEST_MATCH_RUNTIME_BUNDLE';
export const REQUEST_MATCH_RUNTIME_BUNDLE_SUCCESS = 'aiLab/REQUEST_MATCH_RUNTIME_BUNDLE_SUCCESS';
export const REQUEST_MATCH_RUNTIME_BUNDLE_FAILURE = 'aiLab/REQUEST_MATCH_RUNTIME_BUNDLE_FAILURE';
export const CLEAR_RUNTIME_BUNDLE_MATCH = 'aiLab/CLEAR_RUNTIME_BUNDLE_MATCH';

export const REQUEST_FETCH_CATALOG_TOOLS = 'aiLab/REQUEST_FETCH_CATALOG_TOOLS';
export const REQUEST_FETCH_CATALOG_TOOLS_SUCCESS = 'aiLab/REQUEST_FETCH_CATALOG_TOOLS_SUCCESS';
export const REQUEST_FETCH_CATALOG_TOOLS_FAILURE = 'aiLab/REQUEST_FETCH_CATALOG_TOOLS_FAILURE';

export const REQUEST_DELETE_AI_TOOL = 'aiLab/REQUEST_DELETE_AI_TOOL';

export const RECEIVE_AI_TOOL_CONFIGURATION = 'aiLab/RECEIVE_AI_TOOL_CONFIGURATION';
export const REQUEST_AI_TOOL_CONFIGURATION = 'aiLab/REQUEST_AI_TOOL_CONFIGURATION';

export const UPDATE_AI_TOOL_CONFIGURATION = 'aiLab/UPDATE_AI_TOOL_CONFIGURATION';
export const UPDATE_AI_TOOL_CONFIGURATION_SUCCESS = 'aiLab/UPDATE_AI_TOOL_CONFIGURATION_SUCCESS';
export const UPDATE_AI_TOOL_CONFIGURATION_FAILURE = 'aiLab/UPDATE_AI_TOOL_CONFIGURATION_FAILURE';

export const CREATE_AI_TOOL_CONFIGURATION = 'aiLab/CREATE_AI_TOOL_CONFIGURATION';
export const CREATE_AI_TOOL_CONFIGURATION_SUCCESS = 'aiLab/CREATE_AI_TOOL_CONFIGURATION_SUCCESS';
export const CREATE_AI_TOOL_CONFIGURATION_FAILURE = 'aiLab/CREATE_AI_TOOL_CONFIGURATION_FAILURE';

export const SET_AI_TOOL_EXECUTION_COMPLETE = 'aiLab/SET_AI_TOOL_EXECUTION_COMPLETE';
export const SET_AI_TOOL_EXECUTION_FAILED = 'aiLab/SET_AI_TOOL_EXECUTION_FAILED';
